var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.loading),expression:"loading",modifiers:{"body":true}}],class:_vm.loading? 'empty-card':'',attrs:{"id":'SiloMetricsChart' + _vm.metricType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }